import { render, staticRenderFns } from "./WidgetMenu.vue?vue&type=template&id=79bd6e67&"
import script from "./WidgetMenu.vue?vue&type=script&lang=js&"
export * from "./WidgetMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports